import React from "react";

import PT from "prop-types";
import get from "lodash/get";
import { NavbarSearch } from "../navbar-search";
import { MenuItems } from "./menu-items";
import { AppLogo } from "../app-logo";
import { SocialFollow } from "../../basic/social-follow";
import { Couplet } from "./couplet";
import { connect } from "react-redux";

import "./styles.m.css";
import { SisterCompanies } from "../sister-companies";
import { NewsletterSubscribeButton } from "../newsletter-subscribe-button";
import { HamburgerIcon } from "./hamburger-icon";

class NavBarBase extends React.Component {
  constructor() {
    super();
    this.state = {
      hamburgerOpened: false
    };
    this.toggleOffcanvasMenu = this.toggleOffcanvasMenu.bind(this);
  }
  toggleOffcanvasMenu() {
    this.setState({ hamburgerOpened: !this.state.hamburgerOpened });
  }

  render() {
    const styleName = this.props.publisherAttributes.lang === "ur" ? "urdu-search-row-one" : "search-row-one";
    const langClassName = this.props.publisherAttributes.lang === "ur" ? "urdu-navbar" : "navbar";
    const BleedingRowMenuStyle =
      this.props.publisherAttributes.lang === "ur" ? "ur-bleeding-row--menu" : "bleeding-row--menu";
    return (
      <div styleName={langClassName}>
        <div styleName="bleeding-row">
          <div styleName="container container--padded">
            <HamburgerIcon onClick={this.toggleOffcanvasMenu} />
            <AppLogo />
            <SocialFollow
              styleName="social-follow"
              socialLinks={this.props.socialLinks}
              color={this.props.publisherAttributes.lang === "ur" ? "#af33c3" : "#056ff7"}
              width={12}
              height={12}
            />
            <NavbarSearch {...this.props} searchIconColor="#333" styleName={styleName} />
            {this.props.publisherAttributes.lang === "ur" && <Couplet coupletData={this.props.coupletSummary} />}
            <SisterCompanies styleName="sister-companies" />
          </div>
        </div>
        <div styleName={`bleeding-row ${BleedingRowMenuStyle}`}>
          <div styleName={`container menu-container ${this.state.hamburgerOpened ? "menu-container--open" : ""}`}>
            <MenuItems items={get(this.props, ["menu", "default"], [])} closeMenu={this.toggleOffcanvasMenu} />
            {this.props.publisherAttributes &&
              this.props.publisherAttributes["lang"] !== "ur" && <NewsletterSubscribeButton />}
            <NavbarSearch {...this.props} styleName="search-row-two" />
            <div styleName="offcanvas-static-links">
              <p styleName="offcanvas-menu__text">Follow Us</p>
              <SocialFollow
                styleName="social-follow"
                socialLinks={this.props.socialLinks}
                color={this.props.publisherAttributes.lang === "ur" ? "#af33c3" : "#056ff7"}
                width={12}
                height={12}
              />
              <SisterCompanies styleName="sister-companies" />
            </div>
            <div
              styleName={`menu-overlay ${this.state.hamburgerOpened ? "menu-overlay--open" : ""}`}
              onClick={this.toggleOffcanvasMenu}
            />
          </div>
        </div>
      </div>
    );
  }
}

NavBarBase.propTypes = {
  socialLinks: PT.object,
  menu: PT.object
};

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const NavBar = connect(
  mapStateToProps,
  null
)(NavBarBase);
